import React from "react";

const Equlizer = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 24 24"
      {...props}
    >
      <rect className="eq-bar eq-bar--1" x="4" y="4" width="3.7" fill="#ffe26b" height="8" />
      <rect
        className="eq-bar eq-bar--2"
        x="10.2"
        y="4"
        width="3.7"
        fill="#ffe26b"
        height="16"
      />
      <rect
        className="eq-bar eq-bar--3"
        x="16.3"
        y="4"
        width="3.7"
        fill="#ffe26b"
        height="11"
      />
    </svg>
  );
};

export default Equlizer;
